var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GisButton"},[_c('div',{staticClass:"reset",attrs:{"title":"复位"},on:{"click":_vm.resetFn}}),_c('div',{staticClass:"rotate",class:_vm.cameraRotate ? 'rotate_ac' : '',attrs:{"title":"旋转"},on:{"click":_vm.rotateFn}})])
}
var staticRenderFns = []

export { render, staticRenderFns }